<template>
    <router-link v-slot="{ href, navigate }" :to="item.route" custom>
        <a :href="href" v-bind="routerAction" :class="{ 'text-primary': item.route?.includes(route.path) }"
            @click="navigate">
           <LinkContent :icon="item.icon" :label="item.label" /> 
        </a>
    </router-link>
</template>

<script setup lang="ts">
import { MenubarRouterBindProps } from 'primevue/menubar';
import { MenuItem } from 'primevue/menuitem';

defineProps<{ item: MenuItem, routerAction: MenubarRouterBindProps['action'] }>();

const route = useRoute();
</script>